import React, { _useState } from 'react';

import appSettings from '../../config/settings';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';

// Functional Error Boundary using hooks is not possible directly, so we keep a class internally
function LoadableComponentErrorBoundary({ children }) {
  // Error boundaries must be class components, so we use a class inside the function
  class InnerErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { error };
    }

    render() {
      if (this.state.error && this.state.error.name === 'ChunkLoadError') {
        return <LoadableComponentErrorBoundaryPage />;
      }

      return this.props.children;
    }
  }
  return <InnerErrorBoundary>{children}</InnerErrorBoundary>;
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProductionMode = props => {
  const { children } = props;
  return appSettings.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProductionMode;
